<template>
  <default-layout>
    <template slot="center">
      <div class="white-card">
        <div class="loader absolute" v-if="loading"></div>
        <h3>Classement</h3>
        <hr class="m-0">
        <table class="table table-striped">
          <thead>
          <tr>
            <th>Rank</th>
            <th>Nom de l'étudiant</th>
            <th>Points</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(user, i) in users">
            <td>{{ index(i) }}</td>
            <td>{{ user.full_name }}</td>
            <td>{{ user.score }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </template>
  </default-layout>
</template>

<script>
import DefaultLayout from "@/Layout/DefaultLayout";
import axios from 'axios'

export default {
  name: "Ranking",
  components: {DefaultLayout},
  data() {
    return {
      users: [],
      loading: false
    }
  },
  methods: {
    index(i) {
      return parseInt(i) + 1
    }
  },
  mounted() {
    this.loading = true
    axios.get('/ranking')
      .then(({data}) => this.users = data)
      .finally(() => this.loading = false)
  }
}
</script>

<style scoped>

</style>
